import { useFormContext, type FieldValues } from "react-hook-form";
import styles from "./TemplateCustomDuration.module.scss";
import { Trans, useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import InputField from "@medoma/components/InputField/InputField";
import Select from "@medoma/components/Select/Select";
import {
  customDurationUnitOptions,
  customDurationUnitDictionary,
} from "./durationModels";
import {
  useFieldPathWithPrefix,
  useFieldErrorWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/pages/template-manager/TemplateFieldValidationContext";
import type { TemplateCustomDurationFields } from "../../templateFormSchema";

export const TemplateCustomDuration = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const customDurationFieldName =
    useFieldPathWithPrefix<TemplateCustomDurationFields>("customDuration");
  const customDurationUnitFieldName =
    useFieldPathWithPrefix<TemplateCustomDurationFields>("customDurationUnit");
  const durationError = useFieldErrorWithPrefix<TemplateCustomDurationFields>(
    errors,
    "customDuration",
  );
  const unitError = useFieldErrorWithPrefix<TemplateCustomDurationFields>(
    errors,
    "customDurationUnit",
  );
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        <Trans>Annan tid</Trans>
      </legend>
      {durationError ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={durationError} weight="bold" />
        </div>
      ) : null}
      {unitError ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={unitError} weight="bold" />
        </div>
      ) : null}
      <div className={styles.inputWrapper}>
        <InputField
          label={t`Annan tid`}
          hideLabel
          showOptionalLabel={false}
          type="number"
          outerWidth="fit"
          inputWidth="8ch"
          {...register(customDurationFieldName, {
            required: isInFinalValidationPhase
              ? {
                  value: true,
                  message: t`Ange tidsåtgång`,
                }
              : undefined,
            min: {
              value: 1,
              message: t`Tidsåtgången måste vara minst 1 minut`,
            },
          })}
        />
        <Select
          label={t`Enhet för tidsåtgång`}
          hideLabel
          {...register(customDurationUnitFieldName)}
        >
          {customDurationUnitOptions.map((unit) => (
            <option key={unit} value={unit}>
              {t(customDurationUnitDictionary[unit])}
            </option>
          ))}
        </Select>
      </div>
    </fieldset>
  );
};
